import { createSelector } from 'reselect'
import {
  UserConnectionModel,
  UserConnectionResponse,
} from 'src/models/people.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'

export const selectContactsListResponsesFromState = (
  state: RootState,
): Record<string, UserConnectionResponse> => state.data.contacts.listResponses

export const selectContactsListModelsFromState = createSelector(
  [selectContactsListResponsesFromState],
  (peopleListResponses) =>
    Object.values(peopleListResponses).reduce<
      Record<UserConnectionResponse['userTo']['id'], UserConnectionModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.userTo.id]: new UserConnectionModel(curr),
      }),
      {},
    ),
)

export const selectFilteredContactsListModelsFromState = createSelector(
  [selectContactsListModelsFromState, selectUserIdFromState],
  (contactsList, currentUserId) => {
    return Object.values(contactsList).filter(
      (contact) => contact.userTo.id !== currentUserId,
    )
  },
)
